import { EditDefaultPricingRuleDialog } from '@src/containers/Dealer/CustomerPricing/EditDefaultPricingRuleDialog';
import { CustomerFeeTiers } from '@src/containers/Dealer/CustomerPricingTiers/CustomerFeeTiers';
import {
  CustomerPricingTiersLoad,
  useCustomerPricingTiersShared,
} from '@src/containers/Dealer/CustomerPricingTiers/useCustomerPricingTiersShared';
import { CUSTOMER_FEE_TIERS_STANDALONE_PERSIST_KEY } from '@src/containers/Dealer/CustomerPricingTiers/utils';
import type { CustomerFeeTiersPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerFeeTiersPanel({ api, params }: LayoutPanelProps<CustomerFeeTiersPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-fee-tiers-panel"
    >
      <CustomerFeeTiersPanelContent />
    </EntityAdminPanelShell>
  );
}

function CustomerFeeTiersPanelContent() {
  const shared = useCustomerPricingTiersShared(CustomerPricingTiersLoad.Fee);
  return (
    <>
      <EditDefaultPricingRuleDialog
        {...shared.defaultPricingRuleDialog}
        handleEditPricingRule={shared.handleEditPricingRule}
      />
      <CustomerFeeTiers shared={shared} persistKey={CUSTOMER_FEE_TIERS_STANDALONE_PERSIST_KEY} />
    </>
  );
}
